import React from 'react';
import T from 'prop-types';

import SimpleDropdown from '../../../../Dropdowns/SimpleDropdown';

const options = [
  {
    value: 'weekly',
    label: (
      <div className="d-flex flex-column gap-4 py-xxxs">
        <p className="l-h-xxs pt-xxxs">Weekly</p>
        <p className="text-quiet l-h-md pb-xxxs">
          Runs on Monday with data through Sunday of previous week
        </p>
      </div>
    ),
    buttonLabel: 'Weekly',
    className: 'menu-item--14',
  },
  {
    value: 'monthly',
    label: (
      <div className="d-flex flex-column gap-4 py-xxxs">
        <p className="l-h-xxs pt-xxxs">Monthly</p>
        <p className="text-quiet l-h-md pb-xxxs">
          Runs on first day of month with data through last day of previous month
        </p>
      </div>
    ),
    buttonLabel: 'Monthly',
    className: 'menu-item--14',
  },
  {
    value: 'quarterly',
    label: (
      <div className="d-flex flex-column gap-4 py-xxxs">
        <p className="l-h-xxs pt-xxxs">Quarterly</p>
        <p className="text-quiet l-h-md pb-xxxs">
          Runs on first day of calendar quarter with data through last day of previous calendar
          quarter
        </p>
      </div>
    ),
    buttonLabel: 'Quarterly',
    className: 'menu-item--14',
  },
];

const FrequencyDropdown = ({ selected, onChange }) => (
  <SimpleDropdown
    selected={selected}
    options={options}
    menuWidth={282}
    size="lg"
    onChange={onChange}
  />
);

FrequencyDropdown.propTypes = {
  selected: T.string.isRequired,
  onChange: T.func.isRequired,
};

export default FrequencyDropdown;
